var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-spin", { attrs: { size: "large", spinning: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "workshop-container" },
      [
        _vm.step == 1
          ? [
              _c("div", { staticClass: "header" }, [
                _c(
                  "div",
                  { staticClass: "title", class: [_vm.lang] },
                  [
                    _c("a-icon", {
                      staticClass: "icon",
                      style: { "margin-left": _vm.lang == "AR" ? "5px" : 0 },
                      attrs: { type: "home" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.campaign_type == 1
                            ? _vm.$t("AIWorkshop")
                            : _vm.$t("AIWorkRecruiter")
                        ) +
                        " "
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(" " + _vm._s(_vm.$t("AIconverse")) + " "),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "m-title", class: [_vm.lang] },
                [
                  _c("a-icon", {
                    staticClass: "icon",
                    style: { "margin-left": _vm.lang == "AR" ? "5px" : 0 },
                    attrs: { type: "message" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("SetupMethod")) + " "),
                ],
                1
              ),
              _c("div", { staticClass: "setup-methods" }, [
                _c(
                  "div",
                  {
                    staticClass: "method-card",
                    attrs: { "body-style": { padding: "20px" } },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrap-icon" },
                      [
                        _c("a-icon", {
                          staticClass: "icon",
                          attrs: { type: "flag" },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "title", class: [_vm.lang] }, [
                      _vm._v(_vm._s(_vm.$t("AIWorkflow"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "description", class: [_vm.lang] },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("StandardProcessBased")) + " "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "features" }, [
                      _c("div", { staticClass: "item", class: [_vm.lang] }, [
                        _vm._v(" " + _vm._s(_vm.$t("Readyuse")) + " "),
                      ]),
                      _c("div", { staticClass: "item", class: [_vm.lang] }, [
                        _vm._v(" " + _vm._s(_vm.$t("Highconversion")) + " "),
                      ]),
                      _c("div", { staticClass: "item", class: [_vm.lang] }, [
                        _vm._v(" " + _vm._s(_vm.$t("Adjustable")) + " "),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "wrap-btn" },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "btn",
                            class: [_vm.lang],
                            attrs: { type: "primary" },
                            on: { click: _vm.selectHandler },
                          },
                          [_vm._v(_vm._s(_vm.$t("Select")))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "method-card",
                    attrs: { "body-style": { padding: "20px" } },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrap-icon" },
                      [
                        _c("a-icon", {
                          staticClass: "icon",
                          attrs: { type: "dashboard" },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "title", class: [_vm.lang] }, [
                      _vm._v(_vm._s(_vm.$t("TrainingAI"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "description", class: [_vm.lang] },
                      [_vm._v(" " + _vm._s(_vm.$t("TrainAIStyle")) + " ")]
                    ),
                    _c("div", { staticClass: "features" }, [
                      _c("div", { staticClass: "item", class: [_vm.lang] }, [
                        _vm._v(" " + _vm._s(_vm.$t("Fullycustomizable")) + " "),
                      ]),
                      _c("div", { staticClass: "item", class: [_vm.lang] }, [
                        _vm._v(" " + _vm._s(_vm.$t("Styleadaptation")) + " "),
                      ]),
                      _c("div", { staticClass: "item", class: [_vm.lang] }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("Highpersonalization")) + " "
                        ),
                      ]),
                    ]),
                    _vm.scriptList.length == 0
                      ? _c(
                          "div",
                          { staticClass: "wrap-btn" },
                          [
                            _c(
                              "a-button",
                              {
                                staticClass: "btn",
                                class: [_vm.lang],
                                staticStyle: {
                                  "background-color": "rgba(64, 149, 229, 1)",
                                  "border-color": "rgba(64, 149, 229, 1)",
                                },
                                attrs: { type: "primary" },
                                on: { click: _vm.StartCustomizationHandler },
                              },
                              [_vm._v(_vm._s(_vm.$t("StartCustomization")))]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "wrap-btn wrap-btn2" },
                          [
                            _c(
                              "a-button",
                              {
                                staticClass: "btn edit",
                                class: [_vm.lang],
                                staticStyle: {
                                  width: "60px",
                                  "background-color": "rgba(64, 149, 229, 1)",
                                  "border-color": "rgba(64, 149, 229, 1)",
                                },
                                attrs: { type: "primary" },
                                on: { click: _vm.StartCustomizationHandler },
                              },
                              [_vm._v(_vm._s(_vm.$t("Edit")))]
                            ),
                            _c(
                              "a-button",
                              {
                                staticClass: "btn select",
                                class: [_vm.lang],
                                attrs: { type: "primary" },
                                on: { click: _vm.selectHandler2 },
                              },
                              [_vm._v(_vm._s(_vm.$t("Select")))]
                            ),
                          ],
                          1
                        ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "method-card",
                    attrs: { "body-style": { padding: "20px" } },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrap-icon" },
                      [
                        _c("a-icon", {
                          staticClass: "icon",
                          attrs: { type: "tool" },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "title", class: [_vm.lang] }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("WorkflowCustomization")) + " "
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "description", class: [_vm.lang] },
                      [_vm._v(" " + _vm._s(_vm.$t("Fullycustomize")) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "99px",
                          "margin-bottom": "18px",
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "contact-info",
                          class: [_vm.lang],
                          domProps: { innerHTML: _vm._s(_vm.getEmail()) },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "wrap-btn" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btnMail",
                          class: [_vm.lang],
                          attrs: { href: "mailto:info@strategybrain.com" },
                        },
                        [_vm._v(_vm._s(_vm.$t("Contactus")))]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c(
                    "a-button",
                    { class: [_vm.lang], on: { click: _vm.goBack } },
                    [_vm._v(_vm._s(_vm.$t("Back")))]
                  ),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.step == 2
          ? _c("EditScript", {
              attrs: {
                scriptList: _vm.scriptList,
                lgList: _vm.lgList,
                campaign_id: _vm.campaign_id || _vm.$route.query.campaign_id,
                complete: _vm.complete,
                fromStep: _vm.fromStep,
                tempDefaultData: _vm.tempDefaultData,
                campaign_type: _vm.campaign_type,
              },
              on: {
                saveDraft: _vm.saveDraft,
                backHandler: _vm.backHandler,
                setFromStep: _vm.setFromStep,
                setTempDefaultData: _vm.setTempDefaultData,
                getScriptListHandler: _vm.getScriptlist,
                showStep3: _vm.showStep3,
              },
            })
          : _vm._e(),
        _vm.step == 3
          ? _c("Consultation", {
              attrs: {
                campaign_type: _vm.campaign_type,
                campaign_id: _vm.campaign_id || _vm.$route.query.campaign_id,
                fromStep: _vm.fromStep,
              },
              on: {
                backHandler: _vm.backHandler,
                publishDirectly: _vm.publishDirectly,
              },
            })
          : _vm._e(),
        _c(
          "a-modal",
          {
            attrs: {
              centered: "",
              title: _vm.$t("DefaultDialogue"),
              visible: _vm.visible,
              "confirm-loading": _vm.confirmLoading,
              cancelText: "Return to Option",
              width: "800px",
              okText: "Confirm Selection",
              footer: null,
            },
            on: { cancel: _vm.cancelHandler },
          },
          [
            _vm.lgList.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    style: { height: _vm.dialogHeight + "px" },
                  },
                  [
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("1")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("InitialOutreach")
                              : _vm.$t("hrTitle1")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Sendpersonalized")
                                : _vm.$t("hrSubtitle1")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[0].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("2")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("PainPointDiscovery")
                              : _vm.$t("hrTitle2")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Probedeeper")
                                : _vm.$t("hrSubtitle2")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[1].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("3")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("ProductAlignment")
                              : _vm.$t("hrTitle3")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Connectproduct")
                                : _vm.$t("hrSubtitle3")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[2].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("4")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("QASupport")
                              : _vm.$t("hrTitle4")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("RespondingtoUser")
                                : _vm.$t("hrSubtitle4")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[3].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("5")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("ContactCapture")
                              : _vm.$t("hrTitle5")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Guideusers")
                                : _vm.$t("hrSubtitle5")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[4].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("6")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("WhenUsers")
                              : _vm.$t("hrTitle6")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Responsewhen")
                                : _vm.$t("hrSubtitle6")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[5].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("7")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("NeedsMismatch")
                              : _vm.$t("hrTitle7")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Responsewhenrequirements")
                                : _vm.$t("hrSubtitle5")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(" " + _vm._s(_vm.$t("SampleMessage")) + " "),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(_vm.lgList[6].translated_content)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _vm.campaign_type == 2
                      ? _c("div", { staticClass: "item-box" }, [
                          _c("div", { staticClass: "title" }, [
                            _c("span", { staticClass: "index" }, [_vm._v("8")]),
                            _vm._v(_vm._s(_vm.$t("hrTitle8")) + " "),
                          ]),
                          _c("div", { staticClass: "des" }, [
                            _vm._v(" " + _vm._s(_vm.$t("hrSubtitle8")) + " "),
                          ]),
                          _c("div", { staticClass: "cont-box" }, [
                            _c("div", { staticClass: "stitle" }, [
                              _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                            ]),
                            _c("div", {
                              staticClass: "cont",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatText(
                                    _vm.lgList[7].translated_content
                                  )
                                ),
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "footer" },
              [
                _c(
                  "a-button",
                  {
                    class: [_vm.lang],
                    staticStyle: {
                      "background-color": "rgba(0, 0, 0, 0.4)",
                      color: "#fff",
                      "margin-right": "10px",
                    },
                    attrs: { size: "large" },
                    on: { click: _vm.cancelHandler },
                  },
                  [_vm._v(_vm._s(_vm.$t("ReturntoOptions")))]
                ),
                _c(
                  "a-button",
                  {
                    class: [_vm.lang],
                    attrs: { size: "large", type: "primary" },
                    on: { click: _vm.handleOk },
                  },
                  [_vm._v(_vm._s(_vm.$t("ConfirmSelection")))]
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "a-modal",
          {
            attrs: {
              centered: "",
              title: _vm.$t("Customscriptpreview"),
              visible: _vm.visible2,
              "confirm-loading": _vm.confirmLoading,
              cancelText: "Return to Option",
              width: "800px",
              okText: "Confirm Selection",
              footer: null,
            },
            on: { cancel: _vm.cancelHandler2 },
          },
          [
            _vm.scriptList && _vm.scriptList.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    style: { height: _vm.dialogHeight + "px" },
                  },
                  [
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("1")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("InitialOutreach")
                              : _vm.$t("hrTitle1")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Sendpersonalized")
                                : _vm.$t("hrSubtitle1")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[0] &&
                                  _vm.scriptList[0].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("2")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("PainPointDiscovery")
                              : _vm.$t("hrTitle2")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Probedeeper")
                                : _vm.$t("hrSubtitle2")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[1] &&
                                  _vm.scriptList[1].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("3")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("ProductAlignment")
                              : _vm.$t("hrTitle3")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Connectproduct")
                                : _vm.$t("hrSubtitle3")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[2] &&
                                  _vm.scriptList[2].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("4")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("QASupport")
                              : _vm.$t("hrTitle4")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("RespondingtoUser")
                                : _vm.$t("hrSubtitle4")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[3] &&
                                  _vm.scriptList[3].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("5")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("ContactCapture")
                              : _vm.$t("hrTitle5")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Guideusers")
                                : _vm.$t("hrSubtitle5")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[4] &&
                                  _vm.scriptList[4].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("6")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("WhenUsers")
                              : _vm.$t("hrTitle6")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Responsewhen")
                                : _vm.$t("hrSubtitle6")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[5] &&
                                  _vm.scriptList[5].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("7")]),
                        _vm._v(
                          _vm._s(
                            _vm.campaign_type == 1
                              ? _vm.$t("NeedsMismatch")
                              : _vm.$t("hrTitle7")
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.campaign_type == 1
                                ? _vm.$t("Responsewhenrequirements")
                                : _vm.$t("hrSubtitle7")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont-box" }, [
                        _c("div", { staticClass: "stitle" }, [
                          _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                        ]),
                        _c("div", {
                          staticClass: "cont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatText(
                                _vm.scriptList[6] &&
                                  _vm.scriptList[6].simulate_content
                              )
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _vm.campaign_type == 2
                      ? _c("div", { staticClass: "item-box" }, [
                          _c("div", { staticClass: "title" }, [
                            _c("span", { staticClass: "index" }, [_vm._v("8")]),
                            _vm._v(_vm._s(_vm.$t("hrTitle8")) + " "),
                          ]),
                          _c("div", { staticClass: "des" }, [
                            _vm._v(" " + _vm._s(_vm.$t("hrSubtitle8")) + " "),
                          ]),
                          _c("div", { staticClass: "cont-box" }, [
                            _c("div", { staticClass: "stitle" }, [
                              _vm._v(_vm._s(_vm.$t("SampleMessage"))),
                            ]),
                            _c("div", {
                              staticClass: "cont",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatText(
                                    _vm.scriptList[7] &&
                                      _vm.scriptList[7].simulate_content
                                  )
                                ),
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "footer" },
              [
                _c(
                  "a-button",
                  {
                    class: [_vm.lang],
                    staticStyle: {
                      "background-color": "rgba(0, 0, 0, 0.4)",
                      color: "#fff",
                      "margin-right": "10px",
                    },
                    attrs: { size: "large" },
                    on: { click: _vm.cancelHandler2 },
                  },
                  [_vm._v(_vm._s(_vm.$t("ReturntoOptions")))]
                ),
                _c(
                  "a-button",
                  {
                    class: [_vm.lang],
                    attrs: { size: "large", type: "primary" },
                    on: { click: _vm.handleOk2 },
                  },
                  [_vm._v(_vm._s(_vm.$t("ConfirmSelection")))]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }